// When an `el-dialog` may be shown again (phase 071, shared from phase 072).
//
// `el-dialog` 1.0.22 closes in two cycles. The leave transition ends with a
// native `close()`, whose `beforetoggle` makes the element drop its `open`
// attribute; that attribute change runs a second, empty leave transition, and
// when it ends the library schedules one more native `close()` for the next
// animation frame. A dialog shown before that frame runs is shut by it, with
// no click and no key — about 70 ms after the previous closing, which a fast
// Escape-then-Enter reaches (the browser spec of phase 071 reached it on
// every run). The element is idle once nothing in it carries
// `data-transition`, the attribute every cycle holds from its start to its
// end; the trailing `close()` is at most one frame behind that, so the dialog
// is shown two frames later.
export function whenDialogIdle(host: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    const check = (): void => {
      if (host.matches("[data-transition]") || host.querySelector("[data-transition]") !== null) {
        window.requestAnimationFrame(check)
        return
      }
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => resolve()))
    }
    check()
  })
}
